import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { routes } from '@/utils/routes/routes';
const CategoriesSection = ({ themeData }: any) => {
  const navigate = useNavigate();
  return (
    <>
      {' '}
      <section className="cate-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title text-start">
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <h2
                      style={{
                        color: `#${themeData?.theme_3?.home?.section_7?.h2color}`,
                      }}
                    >
                      {themeData?.theme_3?.home?.section_7?.title}
                    </h2>
                  </div>
                  <div className="col-md">
                    <p
                      style={{
                        color: `#${themeData?.theme_3?.home?.section_7?.paracolor}`,
                      }}
                    >
                      {themeData?.theme_3?.home?.section_7?.paragraph}
                    </p>
                  </div>
                  {/* <div className="col-md-auto">
                    <a
                      style={{
                        background: `#${themeData.btn_group.btn1.bg_color}`,
                        color: `#${themeData.btn_group.btn1.color}`,
                      }}
                      href="#book-now"
                      className="btn title-btn hover-btn"
                    >
                      <i className="uil uil-package me-2"></i>{" "}
                      {themeData.btn_group.btn1.text}
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Swiper
                spaceBetween={5}
                navigation={true}
                modules={[Navigation]}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  1024: {
                    slidesPerView: 8,
                  },
                }}
                className="home-slider"
              >
                {themeData?.theme_3?.home?.section_7?.card_section?.collection.map(
                  (item: any) => {
                    return (
                      <SwiperSlide>
                        <div className="card-cate">
                          <img src={item.icon} alt="" />
                          <div className="card-cate-body">
                            <h3
                              style={{
                                color: `#${themeData?.theme_3?.home?.section_7?.h3color}`,
                              }}
                            >
                              {item.card_title}
                            </h3>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.pricing);
                              }}
                              className="btn primary-btn rounded-circle hover-btn"
                            >
                              <i className="uil uil-arrow-right"></i>
                            </a>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  }
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CategoriesSection;
